export const iocGetParameterByName = (window, name) => {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i'),
        results = regex.exec(window.location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

iocGetParameterByName._depends = {
    symbol: '3r/getParameterByName',
    modules: ['window'],
};
